function Divider(props: { background: string; height?: number }) {
  return (
    <div
      style={{
        width: "100%",
        background: props.background,
        minHeight: props?.height ?? 1,
        maxHeight: props?.height ?? 1,
      }}
    />
  );
}

export default Divider;
